import { EventEmitter, Injectable, Output, ViewChild } from "@angular/core";
import { MessageService } from "primeng/api";
import { environment } from "src/environment/environment";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs";
import { LoaderService } from "src/app/core/loader/loader.service";

@Injectable({
    providedIn: 'root',
})
export class VOIPService {

    @Output() onShowSidebar = new EventEmitter<boolean>();
    @Output() onNotificationReaded = new EventEmitter<void>();
    @Output() onIncomingCall = new EventEmitter<any>();

    public isConnected:boolean = false;
    public connectionStatus:string = "";
    private intervalPhoneStatus:any;
    public calls:any[] = [];

    constructor(
        private _http: HttpClient,
        private loaderService: LoaderService
    ) {
    }

    getCallerInfo(phoneNumber:string){
        let url = environment.api_gw + 'voip/integration/caller-info?';
        url += 'phoneNumber=' + phoneNumber;
        return this._http.get(url).pipe(map(response=>response));
    }

    getEndpointsStates(){
        let data = [
            { label: 'Conectado', value: 'not in use', severity: 'success' },
            { label: 'En llamada', value: 'in use', severity: 'warn' },
            { label: 'No conectado', value: 'unavailable', severity: 'danger' },
            { label: 'Sonando', value: 'ringing', severity: 'warn' },
            { label: 'En llamada/Ocupado', value: 'busy', severity: 'warn' }
        ];
        return data;
    }

    pjsipShowEndpoints(){
        let url = environment.api_gw + 'voip/integration/pjsip-show-endpoints';
        this.loaderService.skipRequest(url);
        return this._http.get(url).pipe(map(response=>response));
    }

}
